import React from 'react';

import moment from 'moment';

import UserImage04 from '../../../../../../../assets/images/user-32-04.jpg';

export default function Ticket({
  setInboxSidebarOpen,
  ticket,
  currentTicketId,
  setCurrentTicketId,
  currentCallId,
  setCurrentCallId,
}) {
  const isActive = currentTicketId === ticket.id || currentCallId === ticket.id;

  return (
    <li className="-mx-2">
      <button
        type="button"
        className={
          isActive
            ? 'flex w-full p-2 rounded bg-indigo-100 dark:bg-indigo-500/30 text-left'
            : 'flex w-full p-2 rounded text-left'
        }
        onClick={() => {
          const isCall = !!ticket?.call_data;

          if (isCall) {
            setCurrentCallId(ticket.id);
            setCurrentTicketId(null);
          } else {
            setCurrentTicketId(ticket.id);
            setCurrentCallId(null);
          }

          setInboxSidebarOpen(false);
        }}
      >
        <img
          className="w-8 h-8 rounded-full mr-2"
          src={UserImage04}
          width="32"
          height="32"
          alt="User 05"
        />
        <div className="grow truncate">
          <div className="flex items-center justify-between mb-1.5">
            <div className="truncate">
              <span className="text-sm font-semibold text-slate-800 dark:text-slate-100">
                {ticket.requester?.email}
              </span>
            </div>
            <div className="text-xs text-slate-500 font-medium">
              {moment(ticket?.created_at).format('D MMM')}
            </div>
          </div>
          <div className="text-xs font-medium text-slate-800 dark:text-slate-100 truncate mb-0.5">
            {ticket?.subject}
          </div>
          <div className="text-xs whitespace-normal line-clamp-3 truncate">
            <span>{ticket?.description_text}</span>
          </div>
        </div>
      </button>
    </li>
  );
}
